import type { ExpenseInput } from "../types";
import type { CurrencyConversionCandidate } from "../types/currency-conversions";

/** Category names suggest the control; only a confirmed pair changes financial reporting. */
export const isCurrencyConversionCategory = (category: string): boolean =>
  /^(money|currency)\s*exchange$/i.test(category.trim());

export function conversionChoice(candidate?: CurrencyConversionCandidate) {
  return { conversionTransactionId: candidate?.id ?? "", conversionExpectedUpdatedAt: candidate?.updatedAt };
}

export function validateConversionChoice(input: ExpenseInput): string | null {
  if (!input.conversionTransactionId) return null;
  if ((input.type && input.type !== "Expense" && input.type !== "Income") || input.iouId || input.pending)
    return "Link only settled expense and income entries as a currency conversion.";
  if (!Number.isSafeInteger(input.conversionExpectedUpdatedAt)) return "Select the matching exchange entry again.";
  return null;
}
